import { axiosGet } from '../axios/httpRequest';
/**
 * 后台查询入住记录分页
 */
export const getApiLogApi = params => {
    return axiosGet('/api/api_log/v1/api_log', params);
};
